import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Home } from "@/pages/home/Home";
import { Login } from "@/pages/auth/Login";
import { checkAuth } from "@/store/slices/authSlice";
import { useNotifications } from "@/hooks/useNotifications";
import { actionListThreads } from "@/store/slices/threadSlice";
import { selectIsAuthenticated, selectIsLoading } from "@/store/selectors/auth";
import { useAppDispatch } from "@/hooks/useAppDispatch";
import { env } from "./config/environment";

export function App() {
  const dispatch = useAppDispatch();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const isLoading = useSelector(selectIsLoading);

  const { requestNotificationPermission } = useNotifications();

  useEffect(() => {
    dispatch(checkAuth());
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(actionListThreads());
    }
  }, [isAuthenticated]);

  useEffect(() => {
    requestNotificationPermission();
  }, [requestNotificationPermission]);

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent"></div>
      </div>
    );
  }
  console.log(env);

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={isAuthenticated ? <Home /> : <Navigate to="/login" />}
        />
        <Route
          path="/login"
          element={!isAuthenticated ? <Login /> : <Navigate to="/" />}
        />
      </Routes>
    </Router>
  );
}

export default App;
